import React from 'react';

const eventTypes = [
  'Wedding',
  'Birthday',
  'Corporate Event',
  'Conference',
  'Anniversary',
  'Baby Shower',
  'Graduation',
  'Product Launch',
  'Workshop',
  'Other'
];

function PlanForMeForm({ formData, setFormData }) {
   const today = new Date().toISOString().split("T")[0];

   const handleDateChange = (index, date) => {
    if (index === "eventDate")
      setFormData({
        ...formData,
        eventDate: date,
        startDate: null,
        endDate: null,
      });

    if (index === "startDate")
      setFormData({
        ...formData,
        eventDate: null,
        startDate: date,
      });

    if (index === "endDate") {
      setFormData({
        ...formData,
        eventDate: null,
        endDate: date,
      });
    }
  };

  const handleInputChange = (e) => {
    const { name, value, type, checked } = e.target;
    setFormData({
      ...formData,
      [name]: type === 'checkbox' ? checked : value
    });
  };

   const handleSelectionChange = (e) => {
    const selection = e.target.value;

    if (selection === "single") {
      setFormData({
        ...formData,
        startDate: null,
        endDate: null,
        eventDuration: selection,
      });
    } else if (selection === "multiple") {
      setFormData({ ...formData, eventDate: null, eventDuration: selection });
    }
  };

  return (
    <div className="venue-form-container">
      <div className="form-holder">
        <form>
          <div className="form-items required">
            <label className="form-label">Full Name</label>
            <input
              type="text"
              name="fullName"
              placeholder="Enter your full name"
              value={formData.fullName}
              onChange={handleInputChange}
              required
            />
          </div>

          <div className="form-items required">
            <label className="form-label">WhatsApp Number</label>
            <input
              type="tel"
              name="phone"
              placeholder="0801234567"
              value={formData.phone}
              onChange={handleInputChange}
              required
            />
          </div>

          <div className="form-items required">
            <label className="form-label">Email Address</label>
            <input
              type="email"
              name="email"
              placeholder="yourname@example.com"
              value={formData.email}
              onChange={handleInputChange}
              required
            />
          </div>

          <div className="form-items required">
            <label className="form-label">Type of Event</label>
            <div className="dropdown">
              <select
                name="eventType"
                value={formData.eventType}
                onChange={handleInputChange}
                required
              >
                <option value="">Select event type</option>
                {eventTypes.map((type) => (
                  <option key={type} value={type}>{type}</option>
                ))}
              </select>
            </div>

            {formData?.eventType === "Other" && (
              <input
                className="mt-3"
                type="text"
                name="otherEventType"
                placeholder="Please Specify The Event Type"
                value={formData.otherEventType || ""}
                onChange={handleInputChange}
              />
            )}
          </div>

          <div className="form-items required">
            <label className="form-label">Event Duration</label>
            <>
              <div className="dropdown mb-4">
                <select
                  className="form-control"
                  value={formData.eventDuration}
                  onChange={handleSelectionChange}
                >
                  <option value="">Select Event Duration</option>
                  <option value="single">Single Date</option>
                  <option value="multiple">Multiple Days</option>
                </select>
              </div>
             
            </>
            {formData.eventDuration === "single" && (
              <>
                <div className="date-picker-wrapper">
                  <input
                    type="date"
                    id="eventDate"
                    name="eventDate"
                    min={today}
                    placeholder="Select A Date"
                    value={formData.eventDate || ""}
                    //   className={errors.eventDate ? "error-input" : ""}
                    className="custom-date-input"
                    onChange={(e) =>
                      handleDateChange("eventDate", e.target.value)
                    }
                  />
                </div>
              </>
            )}
            {formData.eventDuration === "multiple" && (
              <>
                <>
                  <div className="form-items ">
                    <label className="form-label">Start Date</label>
                    <input
                      type="date"
                      id="startDate"
                      name="startDate"
                      min={today}
                      value={formData.startDate || ""}
                      //   className={errors.eventDate ? "error-input" : ""}
                      className="custom-date-input"
                      onChange={(e) =>
                        handleDateChange("startDate", e.target.value)
                      }
                    />
                  </div>
                  
                </>
                <>
                  <div className="form-items ">
                    <label className="form-label">End Date</label>
                    <input
                      type="date"
                      id="endDate"
                      name="endDate"
                      min={today}
                      value={formData.endDate || ""}
                      //   className={errors.eventDate ? "error-input" : ""}
                      className="custom-date-input"
                      onChange={(e) =>
                        handleDateChange("endDate", e.target.value)
                      }
                    />
                  </div>
                  {/* {errors.endDate && (
                    <span className="error-text m-0">{errors.endDate}</span>
                  )} */}
                </>
              </>
            )}
          </div>

          <div className="form-items required">
            <label className="form-label">Event Location</label>
            <input
              type="text"
              name="preferredArea"
              placeholder="e.g. Victoria Island, Ikeja, etc."
              value={formData.preferredArea}
              onChange={handleInputChange}
              required
            />
          </div>
          <div className="form-items required">
            <label className="form-label">Budget Range (₦)</label>
            <input
              type="number"
              name="budget"
              placeholder="Enter your budget"
              value={formData.budget}
              onChange={handleInputChange}
              required
              min="0"
            />
          </div>        

          <div className="form-items ">
            <label className="form-label">What Do You Prefer?</label>
            <label className="form-label d-flex  gap-3">
              <input
                type="radio"
                name="servicePreference"
                value="handleEverything"
                checked={formData.servicePreference === "handleEverything"}
                onChange={handleInputChange}
                className="radio-input"
                required
              />
              <span className="check-label">
                I want a planner to handle everything for me
              </span>
            </label>
            <label className="form-label d-flex  gap-3">
              <input
                type="radio"
                name="servicePreference"
                value="handleSpecific"
                checked={formData.servicePreference === "handleSpecific"}
                onChange={handleInputChange}
                className="radio-input"
                required
              />
              <span className="check-label">
                I only want specific services.
              </span>
            </label>
          </div>  

          <div className="form-items">
            <label className="form-label">Additional Details or Preferences (Optional)</label>
            <textarea
              name="additionalDetails"
              placeholder="Any specific requirements, preferences, or additional information..."
              value={formData.additionalDetails}
              onChange={handleInputChange}
              rows="4"
              style={{
                width: '100%',
                padding: '1.1rem 2.2rem',
                borderRadius: '1.4rem',
                border: 'none',
                fontSize: 'clamp(1.4rem, 2vw, 1.8rem)',
                backgroundColor: '#fff',
                boxShadow: '0 2px 10px #00000011',
                outline: 'none',
                resize: 'vertical',
                fontFamily: 'inherit'
              }}
            />
          </div>

          {/* <div className="form-items ">
            <label className="form-label d-flex  gap-3">
              <input
                type="checkbox"
                name="agreeToFee"
                checked={formData.agreeToFee}
                onChange={handleInputChange}
                className="radio-input"
                required
              />
              <span className="check-label">
                I understand the ₦10,000 consultation fee is non-refundable.
              </span>
            </label>
          </div>

          <p className='sub-para'>
            After payment, you’ll receive a confirmation email, and within 1 business day, our support team will review your request, consult with you, and handpick verified event partners to bring your event to life.
          </p> */}
        </form>
      </div>
    </div>
  );
}

export default PlanForMeForm;